<script lang="ts">
  import ContractChangeHikariCollabo from './contractchange/ContractChangeHikariCollabo.svelte';
  import ContractChangeUmobiled from './contractchange/ContractChangeUmobiled.svelte';
  import ContractChangePremium from './contractchange/ContractChangePremium.svelte';
  import { loginUser } from '../components/auth/LoginUser';
  const businessCode = $loginUser.businessCode;
</script>

<!-- 本体 -->
<div class="mb-5 screen-title">
  <span class="text-gray-700 text-2xl font-bold">契約内容変更</span>
</div>
<div>
  {#if businessCode == 'HIKARI_COLLABO'}
    <ContractChangeHikariCollabo />
  {/if}
  {#if businessCode == 'UMOBILE_D' || businessCode == 'UMOBILE_D_ENECOM'}
    <ContractChangeUmobiled />
  {/if}
  {#if businessCode == 'UMOBILE_PREMIUM'}
    <ContractChangePremium />
  {/if}
</div>

<style lang="postcss">
  .screen-title {
    text-align: left;
  }
  @media screen and (max-width: 640px) {
    .screen-title {
      text-align: center;
    }
  }
</style>
